import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import PublicProfilePage from '../../Components/Profile/PublicProfilePage';
import JobModal from '../Boutique/JobModal';
import { getReviewedDemandsAPI } from '../../Store/Actions/demandActions';
import { getPublicMemberProfile } from '../../Services/trustReviews';

const CheckClientProfile = ({ userDemands = [], demandsLoading, getDemands }) => {
  const history = useHistory();
  const location = useLocation();
  const clientId = location.state?.clientId;
  const [client, setClient] = useState(null);
  const [profileLoading, setProfileLoading] = useState(Boolean(clientId));
  const [selectedProject, setSelectedProject] = useState(null);

  useEffect(() => {
    const unsubscribe = getDemands();
    return () => { if (typeof unsubscribe === 'function') unsubscribe(); };
  }, [getDemands]);

  useEffect(() => {
    let active = true;
    if (!clientId) { setProfileLoading(false); return () => { active = false; }; }
    setProfileLoading(true);
    getPublicMemberProfile(clientId)
      .then((profile) => { if (active) setClient(profile); })
      .catch(() => { if (active) setClient(null); })
      .finally(() => { if (active) setProfileLoading(false); });
    return () => { active = false; };
  }, [clientId]);

  const projects = useMemo(
    () => userDemands.filter((demand) => (
      ['paid', 'reviewed'].includes(demand?.demand_status)
      && demand?.user_id === clientId
    )),
    [userDemands, clientId],
  );

  return (
    <>
      <PublicProfilePage
        profile={clientId ? client : null}
        projects={projects}
        role="client"
        loading={Boolean(demandsLoading || profileLoading)}
        onBack={() => history.goBack()}
        onProject={setSelectedProject}
      />
      <JobModal
        showModal={selectedProject ? 'open' : 'close'}
        handleClick={() => setSelectedProject(null)}
        demand={selectedProject}
        viewerRole="artisan"
      />
    </>
  );
};

const mapStateToProps = ({ demands }) => ({
  demandsLoading: Boolean(demands?.loading),
  userDemands: demands?.demands || [],
});
const mapDispatchToProps = (dispatch) => ({
  getDemands: () => dispatch(getReviewedDemandsAPI()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CheckClientProfile);
